export default __webpack_public_path__ + "static/media/cryptogamingpool_image.aa23af81.png";